<template>
  <div class="content">
    <img src="./../../assets/undering .png" alt />
    <p class="txt">
      <slot name="title"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "Undering" // 模块开发中
};
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.txt {
  margin: 10px 0;
  color: #666;
  font-size: 13px;
}
</style>